<template>
  <div>
    <div class="relative flex items-center flex-row gap-2 lg:gap-5">
      <slot name="image">
        <div
          v-if="!noImage"
          class="w-[60px] h-[60px] lg:w-[112px] lg:h-[112px] rounded-full flex items-center justify-center border border-white-100 overflow-hidden shrink-0"
        >
          <img
            v-if="image"
            :src="image"
            alt="title"
            class="w-full h-full object-cover"
          />
          <img
            v-else
            src="/images/default-avatar.png"
            alt="title"
            class="w-full h-full object-cover"
          />
        </div>
      </slot>
      <div class="flex flex-col gap-6 w-full">
        <div class="flex flex-col gap-1 md:gap-3" :class="headClass">
          <div
            class="flex flex-col gap-4 md:flex-row justify-between items-start md:items-start"
          >
            <slot name="title">
              <h1
                class="text-dark font-semibold text-xl lg:text-2xl"
                :class="titleClass"
              >
                {{ title }}
              </h1>
            </slot>
          </div>
          <slot name="subTitle">
            <p
              class="text-sm text-gray leading-130 py-1.5 px-5 rounded-md bg-gray-100 w-fit capitalize"
            >
              {{ subTitle }}
            </p>
          </slot>
        </div>
      </div>
      <div class="absolute top-0 right-0 flex-y-center gap-3">
        <slot name="actions"> </slot>
      </div>
    </div>
    <slot name="content">
      <div
        v-if="!noActions"
        class="grid sm:flex items-center flex-wrap gap-4 mt-6"
      >
        <slot name="details">
          <CProfileDashDetail title="16.09.2022 / 09:41" />

          <CProfileDashDetail
            :title="formatPhoneNumber('+998712007007')"
            description="Номер телефона"
          />
          <CProfileDashDetail description="Электронная почта" />

          <CProfileDashDetail description="Читали" />
        </slot>
      </div>
    </slot>
  </div>
</template>
<script setup lang="ts">
import CProfileDashDetail from "@/components/Profile/CProfileDashDetail.vue";
import { formatPhoneNumber } from "@/utils";
import { ITabItem } from "@/components/Common/Tab/CTab.types";

interface Props {
  image?: string;
  title: string;
  date?: string;
  subTitle?: string;
  tabList?: ITabItem[];
  noTabs?: boolean;
  noImage?: boolean;
  noHr?: boolean;
  titleClass?: string;
  headClass?: string;
  noActions?: boolean;
  active?: string;
}

withDefaults(defineProps<Props>(), {
  title: "Elzodxon",
  date: new Date(),
  subTitle: "",
});
</script>
